import React, { createContext, useContext } from 'react';
import useIdleLogout from '../utils/customeHooks/useIdleLogout'; // Adjust path as needed

const IdleLogoutContext = createContext();

export const IdleLogoutProvider = ({ children }) => {
  const idleLogoutData = useIdleLogout(); // use hook just once

  return (
    <IdleLogoutContext.Provider value={idleLogoutData}>
      {children}
    </IdleLogoutContext.Provider>
  );
};

export const useIdleLogoutContext = () => useContext(IdleLogoutContext);